import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  timeout: 15000,
  withCredentials: true,
});

// Map FastAPI 422 list/object detail to a clean string
export const formatApiError = (e) => {
  const detail = e?.response?.data?.detail;
  if (!detail) return e?.message || "Vessel unreachable";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg || JSON.stringify(d)).join(" · ");
  if (typeof detail === "object") return detail.detail || JSON.stringify(detail);
  return String(detail);
};

export default api;
